import { useState } from 'react'

import type { StartJourneyButtonBaseProps } from 'src/shared/components/ui/buttons/start-journey-button-base'
import StartJourneyButtonBase from 'src/shared/components/ui/buttons/start-journey-button-base'
import StartJourneyDisclaimer from 'src/shared/components/ui/miscellaneous/disclaimer/start-journey-disclaimer'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { useIsAndroid, useIsAppleDevice } from 'src/shared/hooks/use-device-detect'

import { useUserByUsername } from '../../api/accounts/use-user-by-username'

import ProfileStartJourneyPopup from './profile-start-journey-popup'

interface ProfileStartJourneyBtnProps extends StartJourneyButtonBaseProps {
  username: string
}

export default function ProfileStartJourneyBtn({ ...props }: ProfileStartJourneyBtnProps) {
  const { username } = props
  const [isOpen, setIsOpen] = useState(false)
  const { isMobile } = useBreakpoint()
  const isIOS = useIsAppleDevice()
  const isAndroid = useIsAndroid()
  const { data: user } = useUserByUsername(username || '')
  const profileWorkflowAvailable = user?.firstConversationWorkflowAvailable ?? false
  const twilioPhoneNumber = user?.assignedTwilioPhoneNumber

  // If the user is not found or if they don't have a profile workflow available, don't show the button.
  if (!user || !profileWorkflowAvailable || !twilioPhoneNumber) {
    return null
  }

  const firstName = user?.firstName
  const userId = user?.id

  const onClick = () => {
    if (isMobile && (isIOS || isAndroid) && twilioPhoneNumber) {
      const smsNumber = twilioPhoneNumber
      const smsMessage = `Hi Lynk! I'm starting my real estate journey and need help from ${firstName}.`
      // iOS uses '&' separator, Android uses '?' separator
      const separator = isIOS ? '&' : '?'
      const smsUrl = `sms:${smsNumber}${separator}body=${encodeURIComponent(smsMessage)}`
      window.location.href = smsUrl
    } else {
      setIsOpen(true)
    }
  }

  return (
    <div className="flex flex-col items-center">
      <StartJourneyButtonBase {...props} onClick={onClick} />
      <ProfileStartJourneyPopup isOpen={isOpen} setOpen={setIsOpen} userId={userId} />
      {isMobile && <StartJourneyDisclaimer className="mt-3" />}
    </div>
  )
}
